import { IChatUpdateAction } from './types';
import { AT_CHAT_UPDATE } from './constants';
import { TChatCardAction } from '../../chat/actions/types';
import { TChatId } from '../../../../../../../types/rest/IRestChat';

export const chatUpdateAction = (
    id: TChatId,
    action: TChatCardAction,
): IChatUpdateAction => ({
    type: AT_CHAT_UPDATE,
    id,
    action,
});
